import actions from "@/store/modules/nf/actions";
import mutations from "@/store/modules/nf/mutations";
import state from "@/store/modules/nf/state";

export default {
    actions,
    mutations,
    state
}